import {
  ADD_NEW_PRODUCT,
  ADD_TO_CART,
  DECREMENT,
  INCREMENT,
  REMOVE_FROM_CART,
} from "./actionTypes";

const initialState = {
  products: [
    // {
    //   id: 1,
    //   name: "Apple",
    //   price: 100,
    //   category: "Fruit",
    //   image: "https://i.ibb.co/7bQQYkX/Frame.png",
    //   quantity: 10,
    // },
  ],
  cart: [
    // {
    //   id: 1,
    //   name: "Apple",
    //   price: 100,
    //   category: "Fruit",
    //   image: "https://i.ibb.co/7bQQYkX/Frame.png",
    //   quantity: 1,
    // },
  ],
  total: 0,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ADD_NEW_PRODUCT:
      return {
        ...state,
        products: [
          ...state.products,
          {
            ...action.payload,
            id: state.products.length + 1,
          },
        ],
      };
    case ADD_TO_CART:
      return {
        ...state,
        products: state.products.map((product) => {
          if (product.id === action.payload.id && product.quantity > 0) {
            return {
              ...product,
              quantity: product.quantity - 1,
            };
          }
          return product;
        }),
        cart: state.cart.find((product) => product.id === action.payload.id)
          ? state.cart.map((product) => {
              if (product.id === action.payload.id) {
                return {
                  ...product,
                  quantity: product.quantity + 1,
                };
              }
              return product;
            })
          : [
              ...state.cart,
              {
                ...action.payload,
                quantity: 1,
              },
            ],
      };

    case REMOVE_FROM_CART:
      return {
        ...state,
        cart: state.cart.filter((product) => product.id !== action.payload.id),
        products: state.products.map((product) => {
          if (product.id === action.payload.id) {
            return {
              ...product,
              quantity: product.quantity + action.payload.quantity,
            };
          }
          return product;
        }),
      };

    case INCREMENT:
      return {
        ...state,
        cart: state.cart.map((product) => {
          if (product.id === action.payload.id) {
            return {
              ...product,
              quantity: product.quantity + 1,
            };
          }
          return product;
        }),
        products: state.products.map((product) => {
          if (product.id === action.payload.id) {
            return {
              ...product,
              quantity: product.quantity - 1,
            };
          }
          return product;
        }),
      };

    case DECREMENT:
      return {
        ...state,
        cart: state.cart.map((product) => {
          if (product.id === action.payload.id) {
            return {
              ...product,
              quantity: product.quantity - 1,
            };
          }
          return product;
        }),
        products: state.products.map((product) => {
          if (product.id === action.payload.id) {
            return {
              ...product,
              quantity: product.quantity + 1,
            };
          }
          return product;
        }),
      };

    default:
      return state;
  }
}
